// extracted by mini-css-extract-plugin
export var content = "_rr-1";
export var divider = "_rr-0";